// NetworkLicenseRegistration.jsx
import React from "react";

export default function NetworkLicenseRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Network License
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Network License Registration Support
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports Network License registration in
            compliance with telecom and broadcasting regulations, helping
            companies align with DoT, WPC, and, where applicable, Ministry of
            Information &amp; Broadcasting requirements.[web:238][web:240][web:241]
          </p>
          <p className="text-gray-700">
            The service focuses on structuring technical, legal, and company
            information so that license applications meet sector-specific norms
            for communication and broadcasting networks.[web:238][web:240][web:243]
          </p>
        </div>

        {/* Right: Image (square) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/373543/pexels-photo-373543.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Telecom and network infrastructure representing license compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Network License
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps applicants compile the corporate and
              technical documentation typically requested for telecom or
              broadcasting network approvals.[web:238][web:240]
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Company incorporation documents, including Certificate of
                  Incorporation, Memorandum and Articles of Association, and
                  basic KYC for directors and authorized signatories.[web:238][web:240]
                </li>
                <li>
                  Technical details of the proposed network or service
                  (equipment specifications, network architecture, RF or other
                  technical reports where required).[web:240][web:243]
                </li>
                <li>
                  Address proof and registered office details of the company, and
                  where relevant, location or infrastructure details for network
                  nodes or uplink/downlink facilities.[web:238][web:240][web:241]
                </li>
                <li>
                  Any additional undertakings, fee proofs, or financial and net
                  worth information prescribed for specific categories of
                  telecom or broadcasting authorization.[web:238][web:241][web:242]
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers focused support for regulated communication and
              broadcasting services, coordinating legal, technical, and filing
              requirements into a coherent application.[web:238][web:240][web:243]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Sector-Specific Regulatory Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on applicable telecom and broadcasting rules,
                  licensing categories, and the authorities involved in granting
                  network-related permissions.[web:238][web:240][web:242]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Precise Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Assistance in aligning corporate records and technical
                  documentation with prescribed formats, helping reduce queries
                  and resubmissions.[web:238][web:240]
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Service Delivery
                </h3>
                <p className="text-gray-700 text-sm">
                  Structured support from initial assessment through filing and
                  follow-up, providing a consistent interface with sector
                  regulators.[web:239][web:243]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
